import { useMemo } from 'react';
import { AccountType, SingleAccount } from 'utils/api/models/accounts/singleAccount';
import { SingleBillingNumber } from 'utils/api/models/accounts/singleBillingNumber';
import { IExtendedSingleNumber } from 'views/ActiveServices/Details/Numbers';

const useParseFixFbbNumbers = (
	numbers: Array<SingleAccount | SingleBillingNumber | IExtendedSingleNumber>
): Array<SingleAccount | SingleBillingNumber | IExtendedSingleNumber> => {
	const filteredNumbers: Array<SingleAccount | SingleBillingNumber | IExtendedSingleNumber> = useMemo(() => {
		const internetNumbers = numbers
			.filter((num) => num.accountType === AccountType.INTERNET)
			.map(({ accountNum }) => accountNum);
		return numbers.filter(
			({ accountNum, accountType }) =>
				!(accountType === AccountType.FIX && internetNumbers.indexOf(accountNum) >= 0)
		);
	}, [numbers]);
	return filteredNumbers;
};

export default useParseFixFbbNumbers;
